import { TagsNetworkFilterWebComponent } from './component/TagsNetworkFilterWebComponent';
import { WEB_COMPONENT_TAGS_NETWORK_FILTER } from '../../webcomponents.constants';

export { TagsNetworkFilterWebComponent };

window.customElements.define(WEB_COMPONENT_TAGS_NETWORK_FILTER, TagsNetworkFilterWebComponent);
